/**
 * Nombre de archivo de un header `Content-Disposition`. Prioriza `filename*`
 * (RFC 5987, admite acentos) sobre `filename`.
 */
export const nombreArchivoDeDisposition = (header?: string | null): string | null => {
  if (!header) return null;

  const extendido = /filename\*\s*=\s*([^']*)'[^']*'([^;]+)/i.exec(header);
  if (extendido) {
    try {
      return decodeURIComponent(extendido[2].trim());
    } catch {
      // Codificación inválida: se usa `filename`.
    }
  }

  const simple = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i.exec(header);
  const nombre = (simple?.[1] ?? simple?.[2])?.trim();

  return nombre || null;
};
